import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const {
    colorBgPrimaryLight,
    colorTextError,
    colorTextMedium,
    space1,
    space3,
    space4,
    space6,
    space025,
    space05,
    space12,
    space8,
    space2,
  } = theme();

  return StyleSheet.create({
    discount: {
      color: colorTextError,
      marginBottom: space1,
      width: "100%",
    },
    exclusivePrice: {
      marginBottom: space2,
    },
    image: {
      borderColor: colorBgPrimaryLight,
      borderWidth: 1,
    },
    imagesContainer: {
      flexDirection: "row",
      marginHorizontal: "auto",
      paddingLeft: space2,
    },
    imagesWrapper: {
      flex: 1,
    },
    minMargin: {
      marginRight: space05,
    },
    priceContent: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
    },
    priceLineThrough: {
      color: colorTextMedium,
      textDecorationLine: "line-through",
    },
    priceWithDiscount: {
      marginRight: space2,
    },
    productContainer: {
      marginRight: space4,
      width: space12 * 3,
    },
    productDetail: {
      alignItems: "baseline",
    },
    productInfo: {
      justifyContent: "space-between",
      paddingLeft: space3,
      paddingTop: space2,
    },
    productName: {
      color: colorTextMedium,
    },
    productWrapper: {
      display: "flex",
      flexDirection: "column",
      marginRight: space025,
    },
    titleWrapper: {
      marginBottom: space8,
      paddingLeft: space6,
    },
    wrapper: {
      paddingVertical: space8,
    },
  });
};

export { style };
